export default () => {
	setTimeout(function () {
		$('.hero__info').addClass("fadeInRight");
	}, 1000);

	setTimeout(function () {
		$('.hero__btn-wrap').addClass("fadeInRight");
	}, 1500);
}



// WEBPACK FOOTER //
// ./scripts/modules/_hero-slider.js